/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Live_Record_TitleInputs */

const en_us2_workout_live_record_title = /** @type {(inputs: Workout_Live_Record_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New record!`)
};

const pt_br2_workout_live_record_title = /** @type {(inputs: Workout_Live_Record_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Novo recorde!`)
};

const es_419_workout_live_record_title = /** @type {(inputs: Workout_Live_Record_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Nuevo récord!`)
};

const pt_pt2_workout_live_record_title = /** @type {(inputs: Workout_Live_Record_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Novo recorde!`)
};

const fr_fr2_workout_live_record_title = /** @type {(inputs: Workout_Live_Record_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nouveau record !`)
};

const de_de2_workout_live_record_title = /** @type {(inputs: Workout_Live_Record_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neuer Rekord!`)
};

const it_it2_workout_live_record_title = /** @type {(inputs: Workout_Live_Record_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuovo record!`)
};

/**
* | output |
* | --- |
* | "New record!" |
*
* @param {Workout_Live_Record_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_live_record_title = /** @type {((inputs?: Workout_Live_Record_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Live_Record_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_live_record_title(inputs)
	if (locale === "es-419") return es_419_workout_live_record_title(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_live_record_title(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_live_record_title(inputs)
	if (locale === "de-DE") return de_de2_workout_live_record_title(inputs)
	if (locale === "it-IT") return it_it2_workout_live_record_title(inputs)
	return en_us2_workout_live_record_title(inputs)
});
export { workout_live_record_title as "workout-live.record_title" }